import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import FeatureDetail from './FeatureDetail';
import ErrorBoundary, {notifyError, safeTr} from '../components/ErrorBoundary';
import {removeDetailWindow} from '../actions/details';
import '../style/FeatureDetails.css';

class FeatureDetails extends React.Component {
    static propTypes = {
        detailwindows: PropTypes.array,
        removeDetailWindow: PropTypes.func,
        windowSize: PropTypes.object
    }
    static defaultProps = {
        detailwindows: [],
        windowSize: {
            width: 620,
            height: 640
        }
    }

    // A broken window is removed (it would fail again with every render) and the rest keeps working
    onWindowError = (window) => {
        this.props.removeDetailWindow(window);
        notifyError("detailwindow", safeTr("errorboundary.windowfailed", "Ein Fenster konnte nicht angezeigt werden und wurde geschlossen."));
    }

    render() {
        if (!this.props.detailwindows) {
            return null;
        }

        return (
            <div>
                {this.props.detailwindows.map(window => (
                    <ErrorBoundary
                        fallback={null}
                        key={window.id + JSON.stringify(window.feature)}
                        name="Detailfenster"
                        onError={() => this.onWindowError(window)}
                    >
                        <FeatureDetail
                            window={window}
                            windowSize={this.props.windowSize}
                        />
                    </ErrorBoundary>
                ))}
            </div>
        );
    }
}

const selector = (state) => ({
    detailwindows: state.details.detailwindows
});

export default connect(selector, {removeDetailWindow: removeDetailWindow})(FeatureDetails);
